import React, { useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, TextArea, Toast } from "antd-mobile";
import { showGlobalLoading } from "../globalLoading";
import API from "@/api";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";

const Remark: React.FC<{
	data: Record<string, any>;
	onVisiblePopup: (visible: boolean) => void;
}> = ({ data, onVisiblePopup }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const [value, setValue] = useState("");
	const { showLoading, hideLoading } = showGlobalLoading();

	const postUserAgentInviteRemakeHandle = async () => {
		try {
			showLoading();
			const params: any = {
				id: data.uid,
				inviteRemake: value,
			};
			const result: any = await API.members.postUserAgentInviteRemake(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: t("UpdateCompleted"),
					position: "top",
				});
				data.inviteRemake = value;
				setValue("");
			}
		} catch (error) {
			console.log("---postUserAgentInviteRemake--:", error);
		} finally {
			hideLoading();
			onVisiblePopup(false);
		}
	};

	const onSubmit = () => {
		// 不判相同
		if (isEmpty(value)) {
			Toast.show({
				content: t("PleaseEnterRemark"),
				position: "top",
			});
			return;
		}
		postUserAgentInviteRemakeHandle();
	};
	return (
		<div className={classes.applyProportionWrap}>
			<h3>{t("Remark")}</h3>
			<div className="infoRights">
				<div className="addr">
					<TextArea
						value={value}
						onChange={(val) => {
							setValue(val);
						}}
						placeholder={t("PleaseEnterRemark")}
						rows={5}
						style={{
							"--color": "#FFFFFF",
							"--font-size": "16",
							fontWeight: "400",
						}}
					/>
				</div>
			</div>
			<Button
				onClick={onSubmit}
				block
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("Cofirm")}
			</Button>
		</div>
	);
};

export default Remark;

const useStyles = createUseStyles({
	applyProportionWrap: {
		padding: {
			left: pxToRem(14),
			right: pxToRem(14),
			bottom: pxToRem(38),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h3": {
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: "500",
			lineHeight: pxToRem(22),
			padding: {
				top: pxToRem(10),
				bottom: pxToRem(6),
			},
		},

		"& .infoRights": {
			position: "relative",
			height: pxToRem(104),
			padding: pxToRem(12),
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(8),
			backgroundColor: "#181A22",
			marginBottom: pxToRem(24),
			"& .addr": {
				color: "#F7F9FF",
				fontSize: pxToRem(16),
				fontWeight: "500",
				lineHeight: pxToRem(24),
				wordBreak: "break-word",
			},
		},
	},
});
